import { Component, OnInit } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { MessageService } from 'primeng/api';
import {AppBreadcrumbService} from '../../app.breadcrumb.service';
import { BancoService } from '../../_services/banco.service';
import { Banco } from 'src/app/_models/banco/banco';
import { BancoResponse } from 'src/app/_models/response/bancoResponse';
import { Perfil } from 'src/app/_models/usuario/perfil';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { BscobrancaTranslate } from 'src/app/_services/bscobrancatranslate';

@Component({
  templateUrl: 'banco.component.html',
  styleUrls: ['../../demo/view/tabledemo.scss'],
    styles: [`
        :host ::ng-deep .p-dialog .product-image {
            width: 150px;
            margin: 0 auto 2rem auto;
            display: block;
        }

        @media screen and (max-width: 960px) {
            :host ::ng-deep .p-datatable.p-datatable-customers .p-datatable-tbody > tr > td:last-child {
                text-align: center;
            }

            :host ::ng-deep .p-datatable.p-datatable-customers .p-datatable-tbody > tr > td:nth-child(6) {
                display: flex;
            }
        }

    `],
    providers: [MessageService, ConfirmationService]
})


export class BancoComponent implements OnInit {

  bancoDialog: boolean;
  bancos: Banco[];
  banco: Banco;
  selectedBancos: Banco[];
  submitted: boolean;
  cols: any[];
  perfil: Perfil;
  manterBanco: string;
  labelHeader: string;
  header: any[];

  constructor(private bancoService: BancoService, private messageService: MessageService,
              private confirmationService: ConfirmationService, private breadcrumbService: AppBreadcrumbService,
              private authenticationService: AuthenticationService,
              private bscobrancaTranslate: BscobrancaTranslate) {
        this.manterBanco = this.bscobrancaTranslate.getText('menu.manterBanco');
        this.labelHeader = this.bscobrancaTranslate.getText('menu.administracao');
        this.breadcrumbService.setItems([
            { label: this.labelHeader },
            { label: this.manterBanco, routerLink: ['/banco/banco']  }
        ]);
        this.header = ['Codigo Banco', 'Nome Banco'];
    }

  ngOnInit(): void {

     this.bancoService.getAllBancoTodos().toPromise().then(data => this.bancos = data);
     this.perfil = this.authenticationService.atualUserPerfilValue;
     this.cols = [
            { field: 'codBanco', header: 'Codigo Banco' },
            { field: 'nomBanco', header: 'Nome Banco' }
        ];
  }

  openNew() {
        this.banco = {};
        this.submitted = false;
        this.bancoDialog = true;
  }

    deleteSelectedBancos() {
        this.confirmationService.confirm({
            message: 'Are you sure you want to delete the selected products?',
            header: 'Confirm',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.bancos = this.bancos.filter(val => !this.selectedBancos.includes(val));
                this.selectedBancos = null;
                this.messageService.add({severity: 'success', summary: 'Successful', detail: 'Banco Excluido', life: 3000});
            }
        });
    }

    editBanco(banco: Banco) {
        this.banco = {...banco};
        this.bancoDialog = true;
    }

    deleteBanco(banco: Banco) {
        this.confirmationService.confirm({
            message: this.bscobrancaTranslate.getText('mensagens.banco-001') + banco.nmeBanco + '?',
            header: 'Confirm',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.bancoService.deletar(banco).subscribe(
                (bancoResponse: BancoResponse) => {
                    if (bancoResponse) {
                        if (bancoResponse.codigo === 0) {
                            this.bancos = this.bancos.filter(val => val.codBanco !== banco.codBanco);
                            this.banco = {};
                            this.messageService.add({severity: 'success', summary: 'Successful', detail: this.bscobrancaTranslate.getText('mensagens.banco-002'), life: 3000});
                        } else {
                            this.messageService.add({severity: 'error', summary: 'Error', detail: bancoResponse.mensagem, life: 3000});
                        }
                    } else {
                        this.messageService.add({severity: 'error', summary: 'Error', detail: this.bscobrancaTranslate.getText('mensagens.banco-003'),
                        life: 3000});
                    }
                });
            }
        });
    }

    hideDialog() {
        this.bancoDialog = false;
        this.submitted = false;
    }

    saveBanco() {
        this.submitted = true;
        if (this.banco.nmeBanco === '' || this.banco.nmeBanco === null) {
            this.messageService.add({severity: 'error', summary: 'Error',
                detail: this.bscobrancaTranslate.getText('mensagens.banco-004'), life: 3000});
        }
        if (this.banco.nmeBanco.trim()) {
            if (this.banco.codBanco != null) {
                console.log(this.banco);
                this.bancoService.atualizar(this.banco).subscribe(
                (bancoResponse: BancoResponse) => {
                    if (bancoResponse) {
                        if (bancoResponse.codigo === 0) {
                            this.bancos[this.findIndexById(bancoResponse.banco.codBanco)] = bancoResponse.banco;
                            this.messageService.add({severity: 'success', summary: 'Successful',
                            detail: this.bscobrancaTranslate.getText('mensagens.banco-006'), life: 3000});
                            this.bancoService.getAllBancoTodos().toPromise().then(data => this.bancos = data);
                        } else {
                            this.messageService.add({severity: 'error', summary: 'Error', detail: bancoResponse.mensagem, life: 3000});
                        }
                    }
                });
            }
            else {
                this.bancoService.inserir(this.banco).subscribe(
                (bancoResponse: BancoResponse) => {
                    if (bancoResponse) {
                        if (bancoResponse.codigo === 0) {
                            this.bancos.push(bancoResponse.banco);
                            this.messageService.add({severity: 'success', summary: 'Successful',
                            detail: this.bscobrancaTranslate.getText('mensagens.banco-008'), life: 3000});
                            this.bancoService.getAllBancoTodos().toPromise().then(data => this.bancos = data);
                        } else {
                            this.messageService.add({severity: 'error', summary: 'Error', detail: bancoResponse.mensagem, life: 3000});
                        }
                    }
                });
            }

            this.bancos = [...this.bancos];
            this.bancoDialog = false;
            this.banco = {};
        }
    }

    findIndexById(id: number): number {
        let index = -1;
        for (let i = 0; i < this.bancos.length; i++) {
            if (this.bancos[i].codBanco === id) {
                index = i;
                break;
            }
        }
        return index;
    }

    downloadFile(filename= 'bancos') {
        const csvData = this.ConvertToCSV(this.header);
        console.log(csvData);
        const blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
        const dwldLink = document.createElement('a');
        const url = URL.createObjectURL(blob);
        const isSafariBrowser = navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1;
        if (isSafariBrowser) {  // if Safari open in new window to save file with random filename.
            dwldLink.setAttribute('target', '_blank');
        }
        dwldLink.setAttribute('href', url);
        dwldLink.setAttribute('download', filename + '.csv');
        dwldLink.style.visibility = 'hidden';
        document.body.appendChild(dwldLink);
        dwldLink.click();
        document.body.removeChild(dwldLink);
   }

   ConvertToCSV(headerList: any[]) {
         let str = '';
         let row = 'No;';
         // tslint:disable-next-line: forin
         for (const index in headerList) {
             row += headerList[index] + ';';
         }
         row = row.slice(0, -1);
         str += row + '\r\n';
         for (let i = 0; i < this.bancos.length; i++) {
             const banco = this.bancos[i];
             let line = (i + 1) + ';';
             line += banco.codBanco + ';';
             line += banco.nmeBanco + ';';
             str += line + '\r\n';
         }
         return str;
     }

}
